import { Box } from "@mui/material";
import { keyframes } from "@mui/system";
import Iconify from "./Iconify";

const auraPulse = keyframes`
  0%, 100% {
    transform: scale(1);
    box-shadow:
      0 0 0 rgba(255, 196, 90, 0),
      0 0 8px rgba(255, 255, 255, 0.14);
  }
  50% {
    transform: scale(1.06);
    box-shadow:
      0 0 12px rgba(255, 196, 90, 0.55),
      0 0 22px rgba(118, 201, 176, 0.36);
  }
`;

const slowSpin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export default function EDojangNavIcon() {
  return (
    <Box
      sx={{
        width: 28,
        height: 28,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background:
          "radial-gradient(circle at 30% 30%, rgba(255,255,255,0.34), rgba(14,23,38,0.84))",
        animation: `${auraPulse} 3.6s ease-in-out infinite`,
      }}
    >
      <Iconify
        icon="fa-solid:yin-yang"
        width={19}
        sx={{
          color: "#f5f7fa",
          filter: "drop-shadow(0 0 4px rgba(255, 223, 140, 0.72))",
          animation: `${slowSpin} 12s linear infinite`,
        }}
      />
    </Box>
  );
}
